export default ['messages', 'groups', 'videoConversations']
